import bankList from '../constants/bank-list'

export type TSidebarMenu = {
  onClick?: () => void
  pathname?: string
  title: string
  showForGuest: boolean
  openInNewTab: boolean
  isAuthPartner?: boolean
  hideOnDeletionAccount?: boolean
  hideOnSuspend?: boolean
  hideOnDeletedAccountPir?: boolean
}

export type TApiError = { code: string; message: string; errors: any[] }

export type TApiResult<T = object> = {
  error: TApiError
  result: T
  success: boolean
  message: string
  traceId: string
  metadata: { page: number; limit: number; total: number }
}

export enum ESubmissionStatus {
  COMPLETED = 'COMPLETED',
  SCREEN_OUT = 'SCREEN_OUT',
  REJECTED = 'REJECTED',
  OVERQUOTA = 'OVERQUOTA',
  AUTO_DISQUALIFIED = 'AUTO_DISQUALIFIED',
}

export enum ERewardType {
  POINT = 'POINT',
  CASH = 'CASH',
}

export enum SURVEY_CATEGORY {
  DG = 'DG',
  INT = 'INT',
  EXT = 'EXT',
  IEN = 'IEN',
  IPO = 'IPO',
  CGM = 'CGM',
  CTO = 'CTO',
  CDY = 'CDY',
  C = 'C',
  WELCOME_SURVEY = 'WELCOME_SURVEY',
}

export enum SURVEY_PROVIDER {
  GMOR = 'GMOR',
  QUESTION_PRO = 'QUESTION_PRO',
  POPLITE = 'Poplite',
  TOLUNA = 'Toluna',
  DYNATA = 'Dynata',
  PURESPECTRUM = 'PureSpectrum',
}

export enum EUsername {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum EApiErrorCode {
  INPUT_LIMIT_EXCEEDED = 'INPUT_LIMIT_EXCEEDED',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  DUPLICATE_PHONE_NUMBER_EMAIL = 'DUPLICATE_PHONE_NUMBER_EMAIL',
  DUPLICATE_PAYMENT_INFO = 'DUPLICATE_PAYMENT_INFO',
  INVALID_EMAIL_ADDRESS = 'INVALID_EMAIL_ADDRESS',
  NOT_FOUND = 'NOT_FOUND',
  USER_REGISTRATION_RATE_LIMITED = 'USER_REGISTRATION_RATE_LIMITED',
  OTP_REQUEST_LIMIT_EXCEEDED = 'OTP_REQUEST_LIMIT_EXCEEDED',
  LINK_REQUEST_LIMIT_EXCEEDED = 'LINK_REQUEST_LIMIT_EXCEEDED',
  PIN_INPUT_LIMIT_EXCEEDED = 'PIN_INPUT_LIMIT_EXCEEDED',
  OTP_INPUT_LIMIT_EXCEEDED = 'OTP_INPUT_LIMIT_EXCEEDED',
}

export enum ESurveyStatus {
  SURVEY_OVERQUOTA = 'SURVEY_OVERQUOTA',
  SURVEY_DISQUALIFIED = 'SURVEY_DISQUALIFIED',
  SURVEY_NOT_AVAILABLE = 'SURVEY_NOT_AVAILABLE',
  SURVEY_NOT_FOUND = 'SURVEY_NOT_FOUND',
  ALREADY_FINISHED = 'ALREADY_FINISHED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  SURVEY_REJECTED = 'SURVEY_REJECTED',
  SURVEY_COMPLETED = 'SURVEY_COMPLETED',
  SURVEY_SCREEN_OUT = 'SURVEY_SCREEN_OUT',
  SURVEY_TAKEN = 'SURVEY_TAKEN',
  SURVEY_IN_REVIEW_IEN = 'SURVEY_IN_REVIEW_IEN',
  SURVEY_IN_REVIEW_IPO = 'SURVEY_IN_REVIEW_IPO',
  SURVEY_APPROVED = 'SURVEY_APPROVED',
}

export enum ESurveyResultPageUrl {
  SURVEY_OVERQUOTA = 'survey-overquota',
  SURVEY_DISQUALIFIED = 'survey-disqualified',
  SURVEY_NOT_AVAILABLE = 'survey-not-available',
  SURVEY_NOT_FOUND = 'survey-not-found',
  ALREADY_FINISHED = 'already-finished',
  INTERNAL_SERVER_ERROR = 'internal-server-error',
  SURVEY_REJECTED = 'survey-rejected',
  SURVEY_COMPLETED = 'survey-completed',
  SURVEY_SCREEN_OUT = 'survey-screen-out',
  SURVEY_TAKEN = 'survey-taken',
  IN_REVIEW_IPO = 'in-review-ipo',
  IN_REVIEW_IEN = 'in-review-ien',
  SURVEY_APPROVED = 'survey-approved',
}

export enum EPayoutType {
  BANK = 'BANK',
  EWALLET = 'EWALLET',
}

export type TEncryptedCookie = {
  deviceType: string | null
  partnerId: string | null
  isPir?: boolean
  isPnir?: boolean
  userAgent?: string
}

export type TQueryInfo = {
  isBanned: boolean
  isDeleteRequested: boolean
  isRegistered: boolean
  otpRequired: boolean
  twoFactorRequired: boolean
  emailVerified: boolean
  phoneNumberVerified: boolean
  isPINSetup: boolean
  isFinishedOnboarding: boolean
  isGuest: boolean
  isPartner: boolean
  token_verifier: string
  isAcceptUserAgreement: boolean
  partnerStatus: string
  daysLeftForDeletion: number
  linked: {
    isNpr: boolean
    pnir: string[]
    pir: string[]
  }
}

export type TLinkedPartner = {
  partnerId: string
  partnerName: string
  deepLink: string
}

export enum ESpecialPartnerId {
  GOPAY = 'gopay',
}

export type TPayoutInfo = {
  id: string
  type: EPayoutType
  provider: keyof typeof bankList
  accountNumber: string
  accountName: string
  isAutoWithdrawal?: boolean
}

export type TPartnerInfo = {
  fullName: string
}
